<template>
  
  <v-container fluid grid-list-lg>
    <v-layout row align-center>
      <v-flex class="text-xs-center">
        <h1 v-if="provider">One More Step</h1>
        <h1 v-else>Create Your Account Now!</h1>
      </v-flex>
    </v-layout>

    <!--<v-layout row justify-center>
      <v-flex shrink>
        <v-btn icon outline large><v-icon>fab fa-google</v-icon></v-btn>
      </v-flex>
      <v-flex shrink>
        <v-btn icon outline large><v-icon>fab fa-facebook-f</v-icon></v-btn>
      </v-flex>
      <v-flex shrink>
        <v-btn icon outline large><v-icon>fab fa-twitter</v-icon></v-btn>
      </v-flex>
    </v-layout>

    <v-layout row my-2>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 class="text-xs-center" style="overflow: hidden;">
        <div class="strike-sides"><span class="px-5">Or join with your email</span></div>
      </v-flex>
    </v-layout>-->

    <v-layout row justify-center align-center>
      <v-flex shrink style="min-height: 38px;">
        <span class="red--text font-weight-bold" v-html="authError"></span>
      </v-flex>
    </v-layout>

    <v-layout row align-center v-if="loading">
      <v-flex class="text-xs-center">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </v-flex>
    </v-layout>

    <v-layout row align-center wrap v-else>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 class="text-xs-center pt-0" v-if="!provider">
        <v-btn flat outline @click="googleAuth"><v-icon class="mr-2">fab fa-google</v-icon> <span style="font-size: 1.3em;">GOOGLE</span></v-btn>
      </v-flex>
      <v-flex xs12 class="text-xs-center mb-2" v-if="!provider">
        OR
      </v-flex>

      <v-flex xs12 sm6 md3 lg2 offset-md3 offset-lg4 v-if="!provider">
        <div class="field-label">*First Name</div>
        <v-text-field
          v-model="first_name"
          placeholder="First Name"
          solo
          flat
          :error="(authError && !first_name)"
          hide-details
          @input="clearError"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 md3 lg2 v-if="!provider">
        <div class="field-label">*Last Name</div>
        <v-text-field
          v-model="last_name"
          placeholder="Last Name"
          solo
          flat
          :error="(authError && !last_name)"
          hide-details
          @input="clearError"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 v-if="!provider">
        <div class="field-label">*Email</div>
        <v-text-field
          v-model="email"
          placeholder="Email"
          solo
          flat
          :error="(authError && !email)"
          hide-details
          @input="clearError"
        ></v-text-field>
      </v-flex>
      
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 v-if="(!provider || !providerHasBirthday)">

        <v-dialog
          ref="birthdayDialog"
          v-model="birthdayDialog"
          :return-value.sync="birthday"
          persistent
          full-width
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <div class="field-label">*Birthday</div>
            <v-text-field
              :value="(birthday ? $moment(birthday).format('L') : null)"
              
              placeholder="Birthday"
              solo
              flat
              readonly
              v-on="on"
              :error="(authError && !birthday)"
              hint="For styling purposes"
              persistent-hint
            ></v-text-field>

          </template>
          <v-date-picker 
            ref="birthdayPicker"
            v-model="birthday" 
            scrollable
            :max="$moment().subtract(15,'years').format('YYYY-MM-DD')"
            :min="$moment().subtract(110,'years').format('YYYY-MM-DD')"
            @change="birthdaySave"
            color="primary"
          >
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="birthdayDialog = false">Cancel</v-btn>
            <!--<v-btn flat color="primary" @click="$refs.birthdayDialog.save(birthday)">OK</v-btn>-->
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 v-if="!provider">
        <div class="field-label">*Create A Password</div>
        <v-text-field
          v-model="password"
          placeholder="Create A Password"
          type="password"
          solo
          flat
          :error="(authError && !password ? true : false)"
          hide-details
          @input="clearError"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 v-if="!provider">
        <div class="field-label">*Confirm Your Password</div>
        <v-text-field
          v-model="password_confirm"
          placeholder="Confirm Your Password"
          type="password"
          solo
          flat
          :error="(authError && (!password_confirm || password != password_confirm))"
          hide-details
          @input="clearError"
          @keyup="checkKeyup"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 v-if="!$store.getters.referredBy || provider">
        <div class="field-label">How Did You Hear About Us?</div>
        <v-autocomplete
          v-model="heard_about_us"
          placeholder="Choose an option"
          :items="heardAboutUsOptions"
          solo
          flat
          clearable
          hide-details
          @input="clearError"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 class="text-xs-center">
        <v-checkbox
          v-model="receive_texts"
          style="display: inline-block;"
          color="primary"
          hide-details
          class="mt-0"
        ></v-checkbox>
        <span class="body-1">I would like to receive text alerts about my orders</span>
      </v-flex>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 v-if="receive_texts">
        <div class="field-label">Phone</div>
        <v-layout row>
          <v-flex xs4>
            <country-select 
              :prefill="phone_country"
              placeholder="Country"
              short
              :error="(authError && !phone_country)"
              @input="clearError"
              @on-change="phone_country = $event"
            ></country-select>
          </v-flex>
          <v-flex xs8>
            <v-text-field
              v-model="phone_number"
              placeholder="Number"
              solo
              flat
              :error="(authError && !phone_number)"
              hide-details
              @input="clearError"
            ></v-text-field>
          </v-flex>
        </v-layout> 
      </v-flex>
      <v-flex xs12 md6 lg4 offset-md3 offset-lg4 class="text-xs-center">
        <v-checkbox
          v-model="acceptTos"
          style="display: inline-block;"
          color="primary"
          hide-details
          class="mt-0"
        ></v-checkbox>
        <span class="body-1">I accept the <a href="https://trvlporter.com/terms-of-service" target="_blank" style="text-decoration: underline;">Terms of Service</a> and <a href="https://trvlporter.com/privacy-policy" target="_blank" style="text-decoration: underline;">Privacy Policy</a></span>
      </v-flex>
      <v-flex xs12 my-2 class="text-xs-center">
        <v-btn :loading="registering" :disabled="!acceptTos" color="primary" @click="register" style="min-width: 150px;">SUBMIT</v-btn>
      </v-flex>
    </v-layout>

    <v-layout row my-1 v-if="!loading">
      <v-flex xs12 class="text-xs-center">
        <span class="body-1"><router-link :to="{name: 'auth'}">Back to Login</router-link></span>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
import CountrySelect from '@/components/helpers/CountrySelect';

export default {
  name: 'Register',
  components: {
    'country-select': CountrySelect
  },
  data () {
    return {
      loading: true,

      registering: false,
      authError: null,
      birthdayDialog: false,

      first_name: null,
      last_name: null,
      email: null,
      birthday: null,
      password: null,
      password_confirm: null,

      receive_texts: false,
      phone_country: null,
      phone_number: null,

      heard_about_us: null,
      heardAboutUsOptions: [
        'Online Search',
        'Facebook',
        'Instagram',
        'Pinterest',
        'Twitter',
        'Word of Mouth',
        'Event',
        'Press',
        'Other'
      ],

      acceptTos: false,

      providerHasBirthday: false
    }
  },
  mounted: function() {
    if(!this.provider) {
      this.loading = false;
    } else {
      this.checkAuthProvider();
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    provider: function() {
      return this.$route.params.provider;
    }
  },
  watch: {
    authError: function(newVal, oldVal) {
      if(newVal && newVal.trim() != '') this.$swal.fire('Registration Error', newVal);
    },
    birthdayDialog (val) {
      val && setTimeout(() => {
        this.$refs.birthdayPicker.activePicker = 'YEAR';
        if(!this.birthday) {
          setTimeout(() => {
            let dateWindow = document.getElementsByClassName('v-date-picker-years');
            dateWindow[0].scrollTop = 0;
          },200);
        }
      });
    }
  },
  methods: {
    register: function() {
      let ref = this;
      let params = {};

      if(!this.provider) {
        if(!ref.first_name || !ref.last_name || !ref.email || !ref.password || !ref.birthday) {
          ref.authError = 'All fields are required';
          return;
        } else if (ref.receive_texts && (!ref.phone_country || !ref.phone_number)) {
          ref.authError = 'You must enter a country and phone number if you would like text alerts';
          return;
        } else if (ref.password.length < 5) {
          ref.authError = 'Your password must be at least 5 characters long';
          return;
        } else if (ref.password != ref.password_confirm) {
          ref.authError = 'Your password doesn\'t match';
          return;
        }

        params = {
          email: this.email,
          password: this.password,
          first_name: this.first_name,
          last_name: this.last_name,
          birthday: this.birthday,
          heard_about_us: this.heard_about_us,
          referral_code: this.$store.getters.referredBy,
          phone_country: (this.receive_texts ? this.phone_country : null),
          phone: (this.receive_texts ? this.phone_number : null),
          receive_texts: (this.receive_texts ? 1 : 0),
          tac: (this.tac_accepted ? 1 : 0)
        }
      } else {
        if(!ref.birthday) {
          ref.authError = 'Birthday is required';
          return;
        } else if (ref.receive_texts && (!ref.phone_country || !ref.phone_number)) {
          ref.authError = 'You must enter a country and phone number if you would like text alerts';
          return;
        }

        params = {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          birthday: this.birthday,
          heard_about_us: this.heard_about_us,
          referral_code: this.$store.getters.referredBy,
          phone_country: (this.receive_texts ? this.phone_country : null),
          phone: (this.receive_texts ? this.phone_number : null),
          receive_texts: (this.receive_texts ? 1 : 0),
          tac: (this.tac_accepted ? 1 : 0),
          oauth_submission: 1
        };
      }

      this.registering = true;
      this.$http
        .post('auth/register',params)
        .then(response => {
          this.email = null;
          this.password = null;
          this.first_name = null;
          this.last_name = null;
          this.birthday = null;
          this.authError = null;
          
          /*this.$router.push({name: 'auth'});
          this.$swal.fire('Verify Your Email', 'Please check your email to finish your registration', 'success');*/

          this.$store.commit('updateAccessToken', response.data.access_token);
          delete(response.data.access_token);
          this.$store.commit('setUser', response.data);
          this.$router.push({name: 'account-trips'});
          this.$store.dispatch('checkForUpdates');

        })
        .catch(error => {
          let msg = 'There was a problem completing your registration. Please try again.';
          if(error.response.status == '422') {
            if(Array.isArray(error.response.data)) {
              msg = '';
              for(let errmsg of error.response.data) {
                msg += '<div class="error--text">' + errmsg.message + '</div>';
              }
            } else {
              msg = error.response.data.message;
            }
          }
          ref.authError = msg;
        })
        .finally(() => {
          this.registering = false;
        });  
      
    },
    clearError: function(e) {
      this.authError = null;
    },
    checkKeyup: function(e) {
      if(e.key == 'Enter') this.register();
    },

    birthdaySave (date) {
      this.$refs.birthdayDialog.save(date);
    },

    validProvider: function() {
      switch(this.provider) {
        //case 'facebook':
        //case 'twitter':
        case 'google':
          return true;
          break;
        default:
          return false;
      }
    },

    googleAuth: function() {
      let queryParams = [
        'client_id=' + process.env.VUE_APP_GOOGLE_CLIENT_ID,
        'redirect_uri=' + process.env.VUE_APP_URL + 'auth/register/google',
        'response_type=code',
        'scope=email profile openid https://www.googleapis.com/auth/user.birthday.read',
        'prompt=select_account'
      ]
      window.location = 'https://accounts.google.com/o/oauth2/v2/auth?' + queryParams.join('&');
    },
    checkAuthProvider: function() {
      if(!this.validProvider()) {
        this.$swal.fire('Invalid Provider', 'Invalid Oauth provider');
        this.$router.replace({name: 'auth'});
        return;
      }
      if(this.provider == 'google') {
        let params = {
          provider: 'google',
          token: this.$route.query.code,
          redirect_uri: process.env.VUE_APP_URL,
          registering: true
        }
        this.$http.post('auth/verify-oauth', params)
          .then(response => {
            this.first_name = response.data.first_name;
            this.last_name = response.data.last_name;
            this.email = response.data.email;
            if(response.data.birthday) {
              this.birthday = response.data.birthday;
              this.providerHasBirthday = true;
            }
            this.loading = false;
          })
          .catch(err => {
            this.$swal.fire('Error', 'There was an issue getting data from the provider', 'error');
            this.$router.push({name: 'auth'});
          })
      }
    }
  }
}
</script>
<style lang="scss">
  .strike-sides {
    display: inline-block;
    position: relative;
    font-size: 1.2em;
  }
  .strike-sides:after,
  .strike-sides:before {
      content: "";
      position: absolute;
      height: 1px;
      width: 200%;
      top: 50%;
      right: 100%;
      background: rgba(0,0,0,.3);
  }
  .strike-sides:after { left: 100%; }
</style>